module.exports = __webpack_public_path__ + "static/media/TEDMasterclass.dark.bd5360f8.svg";